export const getMaskText = (value = '', mask: string): string => {
  const diff = value.length - mask.length;

  if (diff >= 0) {
    return '';
  }

  const maskUnfilledStart = mask.length - Math.abs(diff);

  return value + mask.substring(maskUnfilledStart);
};
